import { render } from "./BuekArgenIframe.vue?vue&type=template&id=470ab80e&ts=true"
import script from "./BuekArgenIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekArgenIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__